import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a3b1e80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "NoImage Image"
}
const _hoisted_2 = {
  key: 2,
  class: "Empty"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_4 = { class: "UnitType" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "Caption" }
const _hoisted_7 = { class: "Checkmark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.image && _ctx.showImage)
      ? (_openBlock(), _createBlock(_component_Image, {
          key: 0,
          image: _ctx.image,
          dimensions: {width: 40, height: 40},
          transformation: 'square_40'
        }, null, 8, ["image"]))
      : (_ctx.showImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    _createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.unit.getFullTitle()), 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.unitType) + ")", 1),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.countText), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.unit.hasFloorPlan())
        ? (_openBlock(), _createBlock(_component_InlineSVG, {
            key: 0,
            class: "Icon",
            src: require('@/assets/svg/checkmark.svg')
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_InlineSVG, {
      class: "Icon",
      src: require('@/assets/svg/angle-right.svg')
    }, null, 8, ["src"])
  ], 64))
}